<template>
  <main class="home">
    <h1>This is a work page</h1>
  </main>
</template>

<script>
export default {
}
</script>
